import { Details, PreSanctionApproved, PreSanction, PreSanctionCashInProcess, MyPending } from "../Components/index.js";

export default [
    {
        path: "/reports/account/pre-sanction",
        component: PreSanction,
        name: "report.account.pre-sanction-panding",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/reports/account/pre-sanction-my-pending",
        component: MyPending,
        name: "report.account.pre-sanction-my-panding",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/reports/account/pre-sanction/details/:id",
        component: Details,
        name: "report.account.presanction.details",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/reports/pre-sanction/approved",
        component: PreSanctionApproved,
        name: "report.account.presanction.approved",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/reports/pre-sanction/cash-in-process",
        component: PreSanctionCashInProcess,
        name: "report.account.cash-in-process",
        meta: {
            requiresAuth: true,
        },
    },
];
